/**
 * External dependencies
 */
import { AxiosInstance } from 'axios';
import { createAxios } from '@naruto/naruto-api/src/tools';
import Header from '@naruto/naruto-api/src/tools/Header';

/**
 * Internal dependencies
 */
import UserAPI from '@naruto/bgdapp/src/api/user-apis';
import ProjectAPI from '@naruto/bgdapp/src/api/project-apis';
import ServiceAPI from '@naruto/bgdapp/src/api/service-apis';
import ContactAPI from '@naruto/bgdapp/src/api/contact-apis';
import SiteMetaAPI from '@naruto/bgdapp/src/api/site-meta-apis';
import { BaseAPIParams } from './types';

class API {
  private axios: AxiosInstance;

  public baseHeader: Header;

  public user: UserAPI;

  public project: ProjectAPI;

  public service: ServiceAPI;

  public contact: ContactAPI;

  public siteMeta: SiteMetaAPI;

  constructor({ host }: BaseAPIParams) {
    this.axios = createAxios({ host });
    this.baseHeader = new Header();
    this.user = new UserAPI({ axios: this.axios, header: this.baseHeader });
    this.project = new ProjectAPI({ axios: this.axios, header: this.baseHeader });
    this.service = new ServiceAPI({ axios: this.axios, header: this.baseHeader });
    this.contact = new ContactAPI({ axios: this.axios, header: this.baseHeader });
    this.siteMeta = new SiteMetaAPI({ axios: this.axios, header: this.baseHeader });
  }
}

export default API;
